export default __webpack_public_path__ + "static/media/bg1.8bbe6fe2.jpg";